import React, { type PropsWithChildren } from 'react';
import {
  type EmbeddedReportPlaceholderElement,
  type ComponentProps,
} from '@aha-app/aha-editor-v2';

interface EmbeddedReportPlaceholderComponentProps
  extends ComponentProps<EmbeddedReportPlaceholderElement> {}

const EmbeddedReportPlaceholderComponent: React.FC<
  PropsWithChildren<EmbeddedReportPlaceholderComponentProps>
> = ({ attributes, element, children }) => {
  return (
    <div contentEditable={false} {...attributes}>
      <aha-spinner size='18px' stroke='2px' />
      {children}
    </div>
  );
};

export default EmbeddedReportPlaceholderComponent;
